module.exports = __webpack_public_path__ + "img/2026-10-11c_3.6544019c.jpg";